// Per-page renderer for "category-console" — extracted from reportBuilder.js.
// Signature: async (api, doc, ctx) => { y, aiInsights, aiRecommendations }
import autoTable from 'jspdf-autotable';
import { NAVY, fetchPageAI } from '../utils';
import { drawVerticalBarChart, drawDonutChart } from '../charts';

export async function renderCategoryConsole(api, doc, ctx) {
  const { qs, filterDesc, cs, pw, page, filters } = ctx;
  let y = ctx.y;
  let aiInsights = [];
  let aiRecommendations = [];

  const res = await api.get(`/analytics/category-console?${qs}`);
  const d = res.data;

  const catLines = (d.categories || []).map(c => `- ${c.category}: ${cs}${c.total_spend?.toLocaleString()} (${c.spend_percentage?.toFixed(1)}%, ${c.supplier_count} suppliers)`).join('\n');
  const dataContext = `Total Categories: ${d.total_categories}\nTotal Spend: ${cs}${d.total_spend?.toLocaleString()}\n\n${catLines}`;

  try {
    const aiRes = await fetchPageAI(api, { page, dataContext, filterDesc, filters });
    aiInsights = aiRes.insights;
    aiRecommendations = aiRes.recommendations;
  } catch {}

  // KPI cards
  const topCat = d.categories?.[0];
  autoTable(doc, {
    startY: y,
    head: [['Total Spend', 'Categories', 'Top Category', 'Top Category Spend', 'Top Category %']],
    body: [[
      `${cs}${d.total_spend?.toLocaleString()}`,
      String(d.total_categories || 0),
      topCat?.category || 'N/A',
      topCat ? `${cs}${topCat.total_spend?.toLocaleString()}` : 'N/A',
      topCat ? `${topCat.spend_percentage?.toFixed(1)}%` : 'N/A',
    ]],
    styles: { fontSize: 9, halign: 'center' },
    headStyles: { fillColor: NAVY },
    margin: { left: 14, right: 14 },
  });
  y = doc.lastAutoTable.finalY + 8;

  if (d.categories?.length > 0) {
    const chartData = d.categories.slice(0, 10).map(c => ({ label: c.category, value: c.total_spend }));
    y = drawVerticalBarChart(doc, 14, y, pw - 28, 70, chartData, { title: 'Category Spend Distribution' });

    if (y > 190) { doc.addPage(); y = 15; }
    drawDonutChart(doc, 50, y + 30, 24, chartData.slice(0, 8), { title: 'Category Share' });
    y += 75;

    autoTable(doc, {
      startY: y,
      head: [['Category', 'Spend', '% Total', 'Suppliers']],
      body: d.categories.map(c => [c.category, `${cs}${c.total_spend?.toLocaleString()}`, `${c.spend_percentage?.toFixed(1)}%`, String(c.supplier_count)]),
      styles: { fontSize: 7 }, headStyles: { fillColor: NAVY },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  return { y, aiInsights, aiRecommendations };
}
